import { styled } from 'baseui'
import type { Theme } from 'baseui'

interface ThemeProps {
  $theme: Theme
}

export const ChecklistList = styled<'div', { $pulse: boolean }>('div', ({ $pulse }) =>
  $pulse ? { display: 'flex', flexDirection: 'column', gap: '8px' } : { marginBottom: '16px' },
)

export const ChecklistDisclaimer = styled<'p', { $pulse: boolean }>('p', ({ $theme, $pulse }) =>
  $pulse
    ? { margin: 0, fontStyle: 'italic', fontSize: '12px', lineHeight: '17px', color: $theme.colors.textPulseMuted }
    : { marginTop: '8px', fontStyle: 'italic', fontSize: '14px' },
)

export const PulseChecklistCard = styled<'div', { $checked: boolean }>('div', ({ $theme, $checked }) => {
  const borderColor = $checked ? $theme.colors.chipOkBorder : $theme.colors.borderPulse

  return {
    backgroundColor: $checked ? $theme.colors.chipOkBg : $theme.colors.white,
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
  }
})

export const PulseChecklistHeader = styled('div', ({ $theme }: ThemeProps) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '12px',
  paddingRight: '12px',
  fontSize: '13px',
  lineHeight: '18px',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
  cursor: 'pointer',
}))

export const PulseChecklistToggle = styled('button', ({ $theme }: ThemeProps) => ({
  width: '18px',
  flexShrink: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  borderTopWidth: 0,
  borderBottomWidth: 0,
  borderLeftWidth: 0,
  borderRightWidth: 0,
  backgroundColor: 'transparent',
  color: $theme.colors.textPulseMuted,
  fontSize: '14px',
  lineHeight: '18px',
  cursor: 'pointer',
}))

export const PulseChecklistTitle = styled('div', {
  flex: 1,
})

export const PulseChecklistCheckbox = styled('input', ({ $theme }: ThemeProps) => ({
  width: '18px',
  height: '18px',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  flexShrink: 0,
  accentColor: $theme.colors.primaryPulse,
  cursor: 'pointer',
}))

export const PulseChecklistBody = styled('ul', ({ $theme }: ThemeProps) => ({
  marginTop: 0,
  marginBottom: '10px',
  marginLeft: '12px',
  marginRight: '12px',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '28px',
  paddingRight: '12px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
  backgroundColor: $theme.colors.bgPulseCanvas,
  fontSize: '13px',
  lineHeight: '19px',
  color: $theme.colors.textPulseLabel,
}))

export const PulseChecklistItem = styled('li', {
  ':not(:last-child)': {
    marginBottom: '6px',
  },
})
